import { apiFuns } from "sw-hic";
let { get, put, del, post, genStandard, exceptedReqs } = apiFuns;

console.log(exceptedReqs);
const api = {
  /*********** 住院记录 ***********/
  LisRecord: {
    ...genStandard("lisRecord", "/api/proxy", false),
    getWarning: (para) => get(`/api/proxy/lisRecord/warning/list`, para),
    processWarning: (para) => put(`/api/proxy/lisRecord/warning`, para),
  },
};

export default api;